import ApiService from "./api";

const Region = {
    async list() {
        let temp=await ApiService.get('countries');
        console.log(temp.data.data)
        let regions = []
        temp.data.data.forEach((region)=>{
            regions[region.countryGroup]=region.region
        })

        return regions

    }
};

export default Region;